















































































































































































































import { Vue, Component, Lifecycle, Watch, Prop, p, Mixin } from "av-ts";
import { ITopic, IChartData } from "../../interfaces/models";
import Fetcher from "../../services/Fetcher";
import TopicChip from "../util/TopicChip.vue";
import Chart from "./Chart.vue";
import responsiveMixin from "../../responsiveMixin";

interface IChartType {
    name: string,
    value: string
};

@Component({
    components: {
        Chart,
        TopicChip
    }
})
export default class VariableDataVisualiser extends mixin(responsiveMixin, Vue) {
    @Prop
    dataCategories = p<ITopic[]>({
        required: true
    });

    // Subscribable function to provide access to dataset for chartType
    @Prop
    compareList = p<Function>({
        required: true
    });

    @Prop
    selectedUserID = p<number>({
        required: false,
        default: -1
    });

    @Prop
    allowedCurrentChartTypes = p<IChartType[]>({
        required: false,
        default: () => [{
            name: "Bar Chart",
            value: "bar"
        }/*, {
            name: "Radar Chart",
            value: "radar"
        }, /* {
            name: "Topic Dependency Chart",
            value: "topicDependency"
        }, {
            name: "Treemap Chart",
            value: "treemap"
        }*/]
    });

    @Prop
    allowedHistoricalChartTypes = p<IChartType[]>({
        required: false,
        default: () => [{
            name: "Line Chart",
            value: "line"
        }]
    });

    @Prop
    allowedDataTypes = p<IChartType[]>({
        required: false,
        default: () => [{
            name: "Current Ratings",
            value: "current"
        }, {
            name: "Historical Ratings",
            value: "historical"
        }]
    });

    @Prop
    defChartType = p<string>({
        required: false,
        default: "bar"
    });

    pDataGeneratorFunction: Function | undefined = undefined;
    pChartData: { data: any | undefined, options: any | undefined } | undefined = {
        data: undefined,
        options: undefined
    };
    showTopics: {[topicId: number]: boolean} = {};
    
    pDataType: string = "current";
    pTempType: string = "current";
    pChartType: string = this.defChartType;
    pAllowedChartTypes: IChartType[] = this.allowedCurrentChartTypes;

    pExcludeTopics: number[] = [];
    pZeroCompetencyTopics: number[] = [];
    zeroCompetencyClass: boolean = false;

    pDatasets: IChartData | undefined = undefined;

    colourArray: string[] = [
        "rgba(57, 106, 177, .8)",
        "rgba(218, 124, 48, .8)",
        "rgba(62, 150, 81, .8)",
        "rgba(204, 37, 41, .8)",
        "rgba(83, 81, 84, .8)",
        "rgba(107, 76, 154, .8)",
        "rgba(146, 36, 40, .8)",
        "rgba(148, 139, 61, .8)"
    ];

    get allowedChartTypes() {
        return this.pAllowedChartTypes || this.allowedCurrentChartTypes;
    }

    set allowedChartTypes(newVal: IChartType[]) {
        this.pAllowedChartTypes = newVal;
    }

    refreshChart(newDataType: string, newUser: number, oldUser: number) {
        Fetcher.get(this.pDataGeneratorFunction as any,
            { dataType: newDataType, exclude: this.pExcludeTopics, userID: oldUser })
            .off();

        this.pExcludeTopics = this.dataCategories.filter(x => !this.isVisible(x)).map(x => x.id);

        // Register this.compareList with the event bus to ensure synchrocity with the rest of the app
        Fetcher.get(this.pDataGeneratorFunction as any,
            { dataType: newDataType, exclude: this.pExcludeTopics, userID: newUser })
            .on(this.updateChartData);
    }

    get dataType() {
        return this.pDataType;
    }

    set dataType(newType: string) {
        if (newType == "current") {
            this.allowedChartTypes = this.allowedCurrentChartTypes;
        } else {
            this.allowedChartTypes = this.allowedHistoricalChartTypes;
        }
        this.pTempType = newType;
        this.refreshChart(newType, this.selectedUserID, this.selectedUserID);
    }

    get chartType() {
        return this.pChartType;
    }

    set chartType(newType: string) {
        this.pChartType = newType;
    }

    toggleVisible(dataItem: ITopic) {
        if (this.showTopics[dataItem.id]) {
            // this.hiddenData[dataItem.id] = false;
            this.$set(this.showTopics as any, dataItem.id, false);
        } else {
            // this.hiddenData[dataItem.id] = true;
            this.$set(this.showTopics as any, dataItem.id, true);
        }

        this.refreshChart(this.dataType, this.selectedUserID, this.selectedUserID);
    }

    updateChart() {
        //const dim = this.$el.querySelector(".visualisationMenu")!.getBoundingClientRect();
        //const chartContainer = this.$el.querySelector(".chartContainer")! as HTMLDivElement;
        //chartContainer.style.height = dim.height + "px";
    }

    updateChartData(newData: IChartData) {
        this.pDatasets = newData;
        this.pDataType = this.pTempType;
        this.chartType = this.allowedChartTypes[0].value;
    }

    updateBarChartData(newData: IChartData) {
        let cloneData: IChartData = JSON.parse(JSON.stringify(newData));
        const { labels, datasets } = cloneData;
        this.pChartData = undefined;

        for (let dataset of datasets) {
            if (dataset.type == "line") {
                dataset.backgroundColor = "rgba(245, 245, 245, 0.6)";
                dataset.pointBorderColor = dataset.data.map(x => this.getColour(x) + "0.4)");
                dataset.pointBackgroundColor = dataset.data.map(x => this.getColour(x) + "0.6)");
                dataset.showLine = true;
            } else {
                dataset.backgroundColor = dataset.data.map(x => this.getColour(x) + "0.4)");
                dataset.borderColor = dataset.data.map(x => this.getColour(x) + "1)");
                dataset.borderWidth = 2;
            }
        }

        const chartData = {
            data: {
                labels: labels,
                datasets: datasets
            },
            options: {}
        };
        return chartData;
    }

    updateRadarChartData(newData: IChartData) {
        let cloneData: IChartData = JSON.parse(JSON.stringify(newData));
        const { labels, datasets } = cloneData;
        const options = newData.options;

        for (let dataset of datasets) {
            if (dataset.type == "line") { //Class avg
                dataset.type = "radar";
                dataset.pointStyle = "default";
                dataset.backgroundColor = "rgba(0, 0, 0, 0.4)";
                dataset.pointBorderColor = "rgba(0, 0, 0, 0.6)";
                dataset.pointBackgroundColor = "rgba(0, 0, 0, 0.6)";
            } else {
                let filterData = dataset.data.filter(x => x > 0);
                let avgColour = 1111;
                if (Math.max(...filterData) > 100) {
                    avgColour = filterData.reduce((a, b) => a + b, 0) / filterData.length;
                }
                let colour = this.getColour(avgColour);
                dataset.backgroundColor = colour + ".6)";
                dataset.borderColor = colour + "1)";
            }
        }
        const chartData = {
            data: {
                labels: labels,
                datasets: datasets
            },
            options: options
        };
        return chartData;
    }

    updateLineChartData(newData: IChartData) {
        let cloneData: IChartData = JSON.parse(JSON.stringify(newData));
        const { labels, datasets } = cloneData;
        let counter = 0;
        for (let dataset of datasets) {
            dataset.type = "line";
            dataset.pointBorderColor = this.colourArray[counter%8];
            dataset.pointBackgroundColor = this.colourArray[counter%8];
            dataset.fill=false;
            dataset.backgroundColor = this.colourArray[counter%8];
            dataset.borderColor = this.colourArray[counter%8];
            counter++;
        }

        const chartData = {
            data: {
                labels: labels,
                datasets: datasets
            },
            options: {}
        };
        return chartData;
    }

    @Watch("dataCategories")
    changedDataCategories(_newTopics: ITopic[], _oldTopics: ITopic[]) {
        this.pExcludeTopics = this.dataCategories.filter(x => !this.isVisible(x)).map(x => x.id);
        this.dataCategories.forEach(x=> {
            if (this.showTopics[x.id] === undefined) {
                this.showTopics[x.id] = true;
            }
        });
    }

    @Watch("selectedUserID")
    changeUser(newUser: number, oldUser: number) {
        this.refreshChart(this.dataType, newUser, oldUser);
    }

    @Lifecycle
    mounted() {
        window.addEventListener("resize", this.updateChart);
        requestAnimationFrame(() => {
            this.updateChart();
        });
    }

    @Lifecycle
    created() {
        this.pDataGeneratorFunction = this.compareList();
        this.dataCategories.forEach(x=> {
            this.showTopics[x.id] = true;
        });
        this.pExcludeTopics = this.dataCategories.filter(x => !this.isVisible(x)).map(x => x.id);
        // Register this.compareList with the event bus to ensure synchrocity with the rest of the app
        Fetcher.get(this.pDataGeneratorFunction as any,
            { _dataType: this.pDataType, exclude: this.pExcludeTopics, userID: this.selectedUserID })
            .on(this.updateChartData);
    }

    @Lifecycle
    destroyed() {
        window.removeEventListener("resize", this.updateChart);
        Fetcher.get(this.pDataGeneratorFunction as any,
            { _dataType: this.pDataType, exclude: this.pExcludeTopics, userID: this.selectedUserID })
            .off(this.updateChartData);
    }

    getColour(c: number | undefined) {
        if (c === undefined) {
            return undefined;
        }
        if (c < 1000) {
            return "rgba(255, 99, 132, ";
        } else if (c >= 1000 && c <= 1100) {
            return "rgba(255, 206, 86, ";
        } else {
            return "rgba(34, 85, 102, ";
        }
    };

    isVisible(dataItem: ITopic) {
        return !!this.showTopics[dataItem.id];
    }

    getChartClass(chartValue: string) {
        return {
            "chartOption": true,
            "barChart": chartValue == "bar",
            "radarChart": chartValue == "radar",
            /*"topicDependency": chartValue == "topicDependency",*/
            "treemapChart": chartValue == "treemap"
        };
    }

    get chartData() {
        if (this.pDatasets !== undefined) {
            if (this.chartType == "radar") {
                return this.updateRadarChartData(this.pDatasets);
            } else if (this.chartType == "line") {
                return this.updateLineChartData(this.pDatasets);
            } else {
                return this.updateBarChartData(this.pDatasets);
            }
        } else {
            return undefined;
        }
    }

    zeroCompetency(topic: ITopic) {
        if (this.chartType == "bar") {
            if (this.pChartData == undefined || this.pChartData.data == undefined) {
            // const zero = { data: this.pChartData.data,
                // class: "gray-out" };
                return false;
            }
            const index = this.pChartData.data.labels.indexOf(topic.name);
            const value = this.pChartData.data.datasets["0"].data[index];
            if (value == 0) {
                // const zero = { data: this.pChartData.data,
                //     class: "gray-out" };
                return true;
            }
            // Topic is not selected for render or competency is > 0
            // Do not gray out
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/charts/VariableDataVisualiser.vue